export default "__VITE_ASSET__526cb573__"